"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voteToCborObj = exports.isVote = exports.Vote = void 0;
var cbor_1 = require("@harmoniclabs/cbor");
var Vote;
(function (Vote) {
    Vote[Vote["No"] = 0] = "No";
    Vote[Vote["Yes"] = 1] = "Yes";
    Vote[Vote["Abstain"] = 2] = "Abstain";
})(Vote = exports.Vote || (exports.Vote = {}));
Object.freeze(Vote);
function isVote(stuff) {
    return typeof stuff === "number" && (stuff >= 0 && stuff <= 2 &&
        stuff === Math.round(stuff));
}
exports.isVote = isVote;
function voteToCborObj(vote) {
    return new cbor_1.CborUInt(vote);
}
exports.voteToCborObj = voteToCborObj;
